import React from 'react';
import styles from '../../styles/contacts/ContactsWorkspace.module.css';
import { avatarTint, contactInitials } from './contactsData';

/**
 * Monogram avatar. Velox stores no contact photos, so identity is carried by
 * initials on a stable per-contact tint (see avatarTint) rather than a
 * placeholder image.
 */
export default function ContactAvatar({ contact, size = 'sm', className = '' }) {
  const name = contact?.name || '';
  const tint = avatarTint(contact?._id || contact?.email || name);

  return (
    <span
      className={[styles.avatar, size === 'lg' ? styles.avatarLg : '', className].filter(Boolean).join(' ')}
      style={{
        '--avatar-bg': tint.background,
        '--avatar-ring': tint.ring,
        '--avatar-fg': tint.foreground,
      }}
      aria-hidden="true"
    >
      {contactInitials(name)}
    </span>
  );
}
